<template>
  <v-form v-model="check">

    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span> <div>Аттестационное дело соискателя</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
          </v-toolbar>
          <v-card-text v-if="lang.length > 0">

            <v-layout wrap>

              <v-flex md4>
                <v-card-text class="text-xs-left subheading">
                  Фамилия:
                </v-card-text>
                <div v-for="item, i in value.lastName">
                  <v-text-field
                    :error="hasError('lastName')"
                    :error-messages="getError('lastName')"
                    :label=findLang(value.lastName[i].language)
                    required
                    outline
                    v-model="value.lastName[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
              </v-flex>

              <v-flex md4>
                <v-card-text class="text-xs-left subheading">
                  Имя:
                </v-card-text>
                <div v-for="item, i in value.firstName">
                  <v-text-field
                    :error="hasError('firstName')"
                    :error-messages="getError('firstName')"
                    :label=findLang(value.firstName[i].language)
                    required
                    outline
                    v-model="value.firstName[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
              </v-flex>

              <v-flex md4>
                <v-card-text class="text-xs-left subheading">
                  Отчество:
                </v-card-text>
                <div v-for="item, i in value.patronymic">
                  <v-text-field
                    :error="hasError('patronymic')"
                    :error-messages="getError('patronymic')"
                    :label=findLang(value.patronymic[i].language)
                    required
                    outline
                    v-model="value.patronymic[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
              </v-flex>

            </v-layout>
            <v-flex md4>
              <v-text-field
                :error="hasError('birthday')"
                :error-messages="getError('birthday')"
                label= 'Дата рождения'
                required
                type="date"
                outline
                v-model="value.birthday"
                class="pa-1 ma-1"
              > </v-text-field>
            </v-flex>
            <v-layout wrap>

              <v-flex md6>
                <v-card-text class="text-xs-left subheading">
                  Тема диссертационной работы
                </v-card-text>
                <div v-for="item, i in value.thesisTopic">
                  <v-text-field
                    :error="hasError('thesisTopic')"
                    :error-messages="getError('thesisTopic')"
                    :label=findLang(value.thesisTopic[i].language)
                    required
                    outline
                    v-model="value.thesisTopic[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
                <v-autocomplete
                  class="pa-1 ma-1"
                  :error="hasError('dissertationCouncil')"
                  :error-messages="getError('dissertationCouncil')"
                  :items="selectors.dissertationCouncil"
                  label="Диссертационный совет"
                  v-model="value.dissertationCouncil"
                  no-data-text="Нет данных"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6>
                <v-autocomplete
                  :error="hasError('language')"
                  :error-messages="getError('language')"
                  :items="lang"
                  label="Язык защиты"
                  v-model="value.language"
                  item-value="id"
                  item-text="name"
                  no-data-text="Нет данных"
                  class="pa-1 ma-1"
                ></v-autocomplete>
                <v-layout>
                  <v-autocomplete
                    :error="hasError('academicDegree')"
                    :error-messages="getError('academicDegree')"
                    :items="selectors.academicDegree"
                    label="Ученая степень"
                    v-model="value.academicDegree"
                    no-data-text="Нет данных"
                    class="pa-1 ma-1"
                  ></v-autocomplete>
                  <v-card-text>{{textAcadem}}</v-card-text>
                </v-layout>

                <v-autocomplete
                  :error="hasError('organization')"
                  :error-messages="getError('organization')"
                  :items="selectors.organization"
                  label="Организация, в которой выполнена работа"
                  v-model="value.organization"
                  no-data-text="Нет данных"
                  class="pa-1 ma-1"
                ></v-autocomplete>

              </v-flex>


              <v-layout>
                <v-card-text class="text-xs-left title">Добавить научных руководителей:</v-card-text>
                <v-btn flat icon class="primary" @click="addField_scientific_boss">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-layout>

              <div v-if="value.scientificBoss !== null">
                <v-layout v-for="item, i in  value.scientificBoss">


                  <input @change="setFile($event,'scientificBoss',i,'review')"
                         accept="application/pdf,application/vnd.ms-excel" name="image"
                         :ref="'scientificBossinputUploadFile_'+i"
                         style="font-size: 1.2em; padding: 10px 0;"
                         type="file"
                         v-show="false"/>
                  <v-layout wrap>

                    <v-autocomplete
                      class="pa-1 ma-1"
                      :error="hasError('person')"
                      :error-messages="getError('person')"
                      :items="selectors.scientificBoss"
                      label="Научный руководитель"
                      v-model="value.scientificBoss[i].person"
                      no-data-text="Нет данных"
                    >
                      <template v-slot:prepend-item>
                        <v-list-tile
                          ripple
                          @click="addPerson = true"
                        >
                          <v-list-tile-action>
                            <v-icon>add</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>Добавить новое лицо</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>

                    <v-input
                      :error="hasError('scientificBoss')"
                    >
                      Прикрепленный файл отзыв научного руководителя: <a v-if="value.scientificBoss[i].review !==''
                && typeof value.scientificBoss[i].review !== 'object'"
                                                                         :href="value.scientificBoss[i].review"
                                                                         target="_blank" rel="noopener noreferrer">Файл
                      изменений</a>
                      <div
                        v-if="typeof value.scientificBoss[i].review === 'object' && value.scientificBoss[i].review !== null">
                        {{value.scientificBoss[i].review.name}}
                      </div>

                    </v-input>

                    <v-btn v-if="typeof value.scientificBoss[i].review === 'object'
               && value.scientificBoss[i].review !== null" color="primary" flat
                           @click="value.scientificBoss[i].review = null">
                      <v-icon>close</v-icon>
                      Открепить
                    </v-btn>

                    <v-btn v-else @click="$refs['scientificBossinputUploadFile_'+i][0].click()"
                           color="primary"
                           flat>
                      <v-icon>folder_open</v-icon>
                      Прикрепить
                    </v-btn>
                  </v-layout>

                  <v-btn flat icon class="primary"
                         @click="deleteData(i,'scientificBoss',true)">
                    <v-icon>close</v-icon>
                  </v-btn>

                </v-layout>
              </div>


            </v-layout>

            <v-layout v-for="item, i in  value.scientificField">
              <v-autocomplete
                :error="hasError('scientificField')"
                :error-messages="getError('scientificField')"
                :items="selectors.scientificField"
                label="Научная специальность (по отраслям науки)"
                v-model="item.scientificField"
                no-data-text="Нет данных"
                class="pa-1 ma-1"
              ></v-autocomplete>

              <v-btn flat icon class="primary" @click="addField('scientificField')">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn flat icon class="primary" v-if="value.scientificField.length > 1"
                     @click="deleteData(i,'scientificField')">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
            <v-divider class="pt-2"></v-divider>
            <v-layout>
              <v-card-text class="text-xs-left title">Добавить научных консультантов:</v-card-text>
              <v-btn flat icon class="primary" @click="addField_scientific_consultant">
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
            <div v-if="value.scientificConsultant !== null">
              <v-layout v-for="item, i in  value.scientificConsultant">


                <input @change="setFile($event,'scientificConsultant',i,'review')"
                       accept="application/pdf,application/vnd.ms-excel" name="image"
                       :ref="'inputUploadFile_'+i"
                       style="font-size: 1.2em; padding: 10px 0;"
                       type="file"
                       v-show="false"/>
                <v-layout>

                  <v-autocomplete
                    class="pa-1 ma-1"
                    :error="hasError('person')"
                    :error-messages="getError('person')"
                    :items="selectors.scientificBoss"
                    label="Научный консультант"
                    v-model="value.scientificConsultant[i].person"
                    no-data-text="Нет данных"
                  ></v-autocomplete>

                  <v-input
                    :error="hasError('scientificConsultant')"
                  >
                    Прикрепленный файл Научный консультант: <a v-if="value.scientificConsultant[i].review !==''
                && typeof value.scientificConsultant[i].review !== 'object'"
                                                               :href="value.scientificConsultant[i].review"
                                                               target="_blank" rel="noopener noreferrer">Файл
                    изменений</a>
                    <div
                      v-if="typeof value.scientificConsultant[i].review === 'object' && value.scientificConsultant[i].review !== null">
                      {{value.scientificConsultant[i].review.name}}
                    </div>

                  </v-input>

                  <v-btn v-if="typeof value.scientificConsultant[i].review === 'object'
               && value.scientificConsultant[i].review !== null" color="primary" flat
                         @click="value.scientificConsultant[i].review = null">
                    <v-icon>close</v-icon>
                    Открепить
                  </v-btn>

                  <v-btn v-else @click="$refs['inputUploadFile_'+i][0].click()"
                         color="primary"
                         flat>
                    <v-icon>folder_open</v-icon>
                    Прикрепить
                  </v-btn>
                </v-layout>

                <v-btn flat icon class="primary"
                       @click="deleteData(i,'scientificConsultant',true)">
                  <v-icon>close</v-icon>
                </v-btn>

              </v-layout>
            </div>
            <v-divider class="pt-2"></v-divider>
            <div>

              <FileInput
                v-bind:fieldLabel="'заявления'"
                v-bind:field="'statement'"
                v-bind:file=value.statement
                @updateFile="updateFile"
                v-bind:error="hasError('statement')"
                v-bind:error_messages="getError('statement')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'документ об образовании'"
                v-bind:field="'eduDoc'"
                v-bind:file=value.eduDoc
                @updateFile="updateFile"
                v-bind:error="hasError('eduDoc')"
                v-bind:error_messages="getError('eduDoc')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'документ о сдаче кандидатских экзаменов'"
                v-bind:field="'examDoc'"
                v-bind:file=value.examDoc
                @updateFile="updateFile"
                v-bind:error="hasError('examDoc')"
                v-bind:error_messages="getError('examDoc')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'заключение организации'"
                v-bind:field="'organizationConclusion'"
                v-bind:file=value.organizationConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('organizationConclusion')"
                v-bind:error_messages="getError('organizationConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'экспертное заключение о возможности открытого опубликования'"
                v-bind:field="'expertPublicationConclusion'"
                v-bind:file=value.expertPublicationConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('expertPublicationConclusion')"
                v-bind:error_messages="getError('expertPublicationConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'экспертное заключение о прохождении экспортного контроля на внешнеэкономическую\n'+
'                сделку'"
                v-bind:field="'expertTradeConclusion'"
                v-bind:file=value.expertTradeConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('expertTradeConclusion')"
                v-bind:error_messages="getError('expertTradeConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'согласие на обработку персональных данных'"
                v-bind:field="'personalDataConsent'"
                v-bind:file=value.personalDataConsent
                @updateFile="updateFile"
                v-bind:error="hasError('personalDataConsent')"
                v-bind:error_messages="getError('personalDataConsent')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'копия паспорта'"
                v-bind:field="'passport'"
                v-bind:file=value.passport
                @updateFile="updateFile"
                v-bind:error="hasError('passport')"
                v-bind:error_messages="getError('passport')"
              ></FileInput>

              <v-divider class="mt-2"></v-divider>

              <FileInput
                v-bind:fieldLabel="'Диссертация (PDF)'"
                v-bind:field="'thesisPDF'"
                v-bind:file=value.thesisPDF
                @updateFile="updateFile"
                v-bind:error="hasError('thesisPDF')"
                v-bind:error_messages="getError('thesisPDF')"
              ></FileInput>

<!--              <FileInput-->
<!--                v-bind:fieldLabel="'Диссертация (WORD)'"-->
<!--                v-bind:field="'thesisWORD'"-->
<!--                v-bind:file=value.thesisWORD-->
<!--                @updateFile="updateFile"-->
<!--                v-bind:error="hasError('thesisWORD')"-->
<!--                v-bind:error_messages="getError('thesisWORD')"-->
<!--              ></FileInput>-->

              <FileInput
                v-bind:fieldLabel="'Автореферат'"
                v-bind:field="'synopsis'"
                v-bind:file=value.synopsis
                @updateFile="updateFile"
                v-bind:error="hasError('synopsis')"
                v-bind:error_messages="getError('synopsis')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Аннотация'"
                v-bind:field="'annotation'"
                v-bind:file=value.annotation
                @updateFile="updateFile"
                v-bind:error="hasError('annotation')"
                v-bind:error_messages="getError('annotation')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Заключение комиссии по русскому языку'"
                v-bind:field="'expertInternetPublicationConclusion'"
                v-bind:file=value.expertInternetPublicationConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('expertInternetPublicationConclusion')"
                v-bind:error_messages="getError('expertInternetPublicationConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Заключение комиссии по предварительному рассмотрению'"
                v-bind:field="'expertReviewConclusion'"
                v-bind:file=value.expertReviewConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('expertReviewConclusion')"
                v-bind:error_messages="getError('expertReviewConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Протокол заседания диссертационного совета о приеме диссертации к защите'"
                v-bind:field="'councilReviewProtocol'"
                v-bind:file=value.councilReviewProtocol
                @updateFile="updateFile"
                v-bind:error="hasError('councilReviewProtocol')"
                v-bind:error_messages="getError('councilReviewProtocol')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Явочный лист заседания диссертационного совета о приеме диссертации к защите'"
                v-bind:field="'councilReviewLeafSheet'"
                v-bind:file=value.councilReviewLeafSheet
                @updateFile="updateFile"
                v-bind:error="hasError('councilReviewLeafSheet')"
                v-bind:error_messages="getError('councilReviewLeafSheet')"
              ></FileInput>

              <v-divider class="mt-2"></v-divider>

              <v-layout class="mt-2" wrap>
                <v-autocomplete
                  class="pa-1 ma-1"
                  :error="hasError('location')"
                  :error-messages="getError('location')"
                  :items="selectors.location"
                  label="Место проведения защиты"
                  v-model="value.location"
                  no-data-text="Нет данных"
                ></v-autocomplete>

                <v-text-field
                  :error="hasError('room')"
                  :error-messages="getError('room')"
                  label="Помещение"
                  required
                  v-model="value.room"
                  class="pa-1 ma-1"
                ></v-text-field>

                <v-text-field
                  :error="hasError('protectionDate')"
                  :error-messages="getError('protectionDate')"
                  label="Дата защиты диссертации"
                  required
                  type="date"
                  v-model="value.protectionDate"
                  class="pa-1 ma-1"
                ></v-text-field>
                <v-text-field
                  :error="hasError('publicationDate')"
                  :error-messages="getError('publicationDate')"
                  label="Дата публикации"
                  required
                  type="date"
                  v-model="value.publicationDate"
                  class="pa-1 ma-1"
                ></v-text-field>
              </v-layout>

              <v-divider class="mt-1"></v-divider>

              <ListReview_organization v-if="value.id"
                v-bind:candidateCase= value.id
                v-bind:disable=true>
              </ListReview_organization>
              <ListReview_opponent v-if="value.id"
                v-bind:candidateCase= value.id
                v-bind:disable=true>
              </ListReview_opponent>
              <ListReview_person v-if="value.id"
                v-bind:candidateCase= value.id
                v-bind:disable=true>
              </ListReview_person>
              <v-divider class="mt-1"></v-divider>

              <FileInput
                v-bind:fieldLabel="'Протокол заседания диссертационного совета по защите'"
                v-bind:field="'councilProtectionProtocol'"
                v-bind:file=value.councilProtectionProtocol
                @updateFile="updateFile"
                v-bind:error="hasError('councilProtectionProtocol')"
                v-bind:error_messages="getError('councilProtectionProtocol')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Явочный лист заседания диссертационного совета по защите'"
                v-bind:field="'councilProtectionLeafSheet'"
                v-bind:file=value.councilProtectionLeafSheet
                @updateFile="updateFile"
                v-bind:error="hasError('councilProtectionLeafSheet')"
                v-bind:error_messages="getError('councilProtectionLeafSheet')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Протокол счетной комиссии заседания диссертационного совета по защите'"
                v-bind:field="'countingCommissionProtectionProtocol'"
                v-bind:file=value.countingCommissionProtectionProtocol
                @updateFile="updateFile"
                v-bind:error="hasError('countingCommissionProtectionProtocol')"
                v-bind:error_messages="getError('countingCommissionProtectionProtocol')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Заключение диссертационного совета по защите'"
                v-bind:field="'councilProtectionConclusion'"
                v-bind:file=value.councilProtectionConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('councilProtectionConclusion')"
                v-bind:error_messages="getError('councilProtectionConclusion')"
              ></FileInput>

              <v-divider class="mt-1"></v-divider>
              <v-layout class="mt-1">
                <v-flex md6>
                  <v-text-field
                    :error="hasError('certificationCommissionMeetingDate')"
                    :error-messages="getError('certificationCommissionMeetingDate')"
                    label="Дата заседания аттестационной комисси"
                    required
                    type="date"
                    v-model="value.certificationCommissionMeetingDate"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </v-flex>
                <v-flex md6>
                  <FileInput
                    v-bind:fieldLabel="'Выписка из протокола заседания аттестационной комиссии'"
                    v-bind:field="'certificationCommissionProtocol'"
                    v-bind:file=value.certificationCommissionProtocol
                    @updateFile="updateFile"
                    v-bind:error="hasError('certificationCommissionProtocol')"
                    v-bind:error_messages="getError('certificationCommissionProtocol')"
                  ></FileInput>
                </v-flex>
              </v-layout>
              <v-divider class="mt-1"></v-divider>
              <v-layout wrap>
                <v-flex md6>
                  <v-text-field
                    :error="hasError('rectorOrderNumber')"
                    :error-messages="getError('rectorOrderNumber')"
                    label="Номер приказа ректора о выдаче диплома"
                    required
                    v-model="value.rectorOrderNumber"
                    class="pa-1 ma-1"
                  ></v-text-field>

                  <v-text-field
                    :error="hasError('rectorOrderDate')"
                    :error-messages="getError('rectorOrderDate')"
                    label="Дата приказа ректора о выдаче диплома"
                    required
                    type="date"
                    v-model="value.rectorOrderDate"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    :error="hasError('diplomaSeries')"
                    :error-messages="getError('diplomaSeries')"
                    label="Серия бланка диплома об ученой степени"
                    required
                    v-model="value.diplomaSeries"
                    class="pa-1 ma-1"
                  ></v-text-field>

                  <v-text-field
                    :error="hasError('diplomaNumber')"
                    :error-messages="getError('diplomaNumber')"
                    label="Номер бланка диплома об ученой степени"
                    required
                    v-model="value.diplomaNumber"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <FileInput
                v-bind:fieldLabel="'Приказ ректора о выдаче диплома'"
                v-bind:field="'rectorOrder'"
                v-bind:file=value.rectorOrder
                @updateFile="updateFile"
                v-bind:error="hasError('rectorOrder')"
                v-bind:error_messages="getError('rectorOrder')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'Копия диплома'"
                v-bind:field="'diploma'"
                v-bind:file=value.diploma
                @updateFile="updateFile"
                v-bind:error="hasError('diploma')"
                v-bind:error_messages="getError('diploma')"
              ></FileInput>
              <v-layout>
                <v-autocomplete
                  :error="hasError('status')"
                  :error-messages="getError('status')"
                  :items="selectors.nextStatus"
                  label="Статус дела"
                  v-model="value.status"
                  no-data-text="Нет данных"
                  class="pa-1 ma-1"
                ></v-autocomplete>

                <v-flex md6>
                  <v-card flat style="height: 15vh; overflow-y: scroll">
                    <template v-for="item in historyStatus">
                      <v-card class="pa-1" color="grey lighten-2" flat>
                        <v-card-title class="pa-1 text-xs-left">
                          {{findNameObj('status',item.status)}}
                          - {{displayDate(item.setDate,true)}}
                        </v-card-title>
                      </v-card>
                    </template>

                  </v-card>
                </v-flex>
              </v-layout>

            </div>

            <v-btn @click="apply" color="primary" block>Сохранить</v-btn>
          </v-card-text>
          <v-progress-circular v-else class="mt-3"
                               :size="70"
                               color="primary"
                               indeterminate
          />
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Review @addItem="closedForm"
              @ended="closedForm"
              @refreshItem="closedForm"
              v-bind="selected"
              v-bind:disable=true
              v-if="opened_form"
      >
      </Review>
    </v-dialog>
    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить Отзыв?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout justify-center row>
      <v-dialog max-width="290" persistent v-model="successPathBool">
        <v-card>
          <v-card-title class="headline">Изменение анкеты</v-card-title>
          <v-card-text>Данные анкеты были успешно измененны
          </v-card-text>
          <v-card-actions>
            <v-btn @click="successPathBool = false" block color="green darken-1">ОК</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-form>
</template>


<script>

    // import urls from "../../../../../urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {makeGetRequest, makePostRequestFile} from "../../../../../helper";
    import FileInput from "../../../../diss/components/FileInput"
    import moment from 'moment'
    import Review from "./Review_person.vue"
    import ListReview_opponent from "../page/ListReview_opponent";
    import ListReview_person from "../page/ListReview_person";
    import ListReview_organization from "../page/ListReview_organization";

    export default {
        name: "ProgressApplication",
        mixins: [UserDataFormMixin,UserDataMixin],
        components: {FileInput,Review, ListReview_opponent,ListReview_person,ListReview_organization,},
        props: {
            id: Number,
        },


        data() {
            return {
                historyStatus: [],
                check: true,
                //переменные для окошка успеха
                successPathBool: false,
                //переменные для отзывов
                URL_DELETE:  process.env.VUE_APP_API_HOST +"council/admin/case/models/review/<id>/",
                opened_form: false,
                loading: true,
                total: 0,
                items: [],
                pagination: {},
                selected: {},
                headers: [
                    {
                        text: 'Организация',
                        align: 'justify-center',
                        sortable: false,
                    },
                    {
                        text: 'Оппонент', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    },
                    {
                        text: 'Файл', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ],
                //все для анкеты
                URL_CREATE: process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case/",
                URL_UPDATE: process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case/<id>/",
                lang: [],

                selectors: {
                    academicDegree: [],
                    organization: [],
                    scientificBoss: [],
                    scientificField: [],
                    dissertationCouncil: [],
                    location: [],
                    status: [],
                    nextStatus: [],
                },

                value: {
                    id: null,
                    status: null,
                    lastName: [],
                    firstName: [],
                    patronymic: [],
                    thesisTopic: [],
                    language: null,
                    birthday: null,
                    academicDegree: null,
                    scientificField: [
                        {
                            scientificField: null,
                        }],
                    organization: null,
                    scientificBoss: null,
                    scientificConsultant: null,
                    statement: null,
                    eduDoc: null,
                    examDoc: null,
                    organizationConclusion: null,
                    expertPublicationConclusion: null,
                    expertTradeConclusion: null,
                    personalDataConsent: null,
                    passport: null,
                    dissertationCouncil: null,
                    thesisPDF: null,
                    thesisWORD: null,
                    synopsis: null,
                    annotation: null,
                    expertInternetPublicationConclusion: null,
                    expertReviewConclusion: null,
                    councilReviewProtocol: null,
                    councilReviewLeafSheet: null,
                    location: null,
                    room: null,
                    protectionDate: null,
                    publicationDate: null,
                    councilProtectionProtocol: null,
                    councilProtectionLeafSheet: null,
                    countingCommissionProtectionProtocol: null,
                    councilProtectionConclusion: null,
                    certificationCommissionProtocol: null,
                    certificationCommissionMeetingDate: null,
                    rectorOrder: null,
                    rectorOrderNumber: null,
                    rectorOrderDate: null,
                    diplomaSeries: null,
                    diplomaNumber: null,
                    diploma: null,
                },

            }
        },
        watch: {
            pagination: {
                handler() {
                    this.getItems()
                },
                deep: true
            }
        },
        computed: {
            // геттер вычисляемого значения
            textAcadem() {
                if (this.value.scientificField[0] === undefined)
                    return "";
                if (this.value.scientificField[0].scientificField === null || this.value.scientificField[0].scientificField === undefined) {
                    return "";
                } else {
                    var lists = this.value.scientificField
                    let name = ""
                    for (let str in lists) {
                        name = this.selectors.scientificField.find(x => x.value === lists[str].scientificField);
                    }
                    if (name !== undefined) {
                        let patt = /\(([^\(\)]+)\)/gmi;
                        let pp = patt.exec(name.text);
                        return pp[1];
                    }
                    return " ";
                }
            },
        },
        methods: {
          addField_scientific_boss() {
            if (this.value.scientificBoss === null)
              this.value.scientificBoss = []
            this.value.scientificBoss.push(
              {
                "person": null,
                "review": null,
              }
            )
          },
            closedForm: function () {
                this.selected = {};
                this.opened_form = false
                this.getItems()
            },
            //Вывод даты
            displayDate: function (date, minutes = false) {
                let format = 'DD.MM.YYYY'
                if (minutes)
                    format += ' HH:mm'
                return moment(date).format(format)
            },
//данные таблички
            getItems() {
                this.loading = true
                let url = process.env.VUE_APP_API_HOST + "council/admin/case/models/review/" + "?page=" + this.pagination.page + "&page_size=" + this.pagination.rowsPerPage
                    + "&candidateCase=" + this.id
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                })
            },
            //история статусов
            LoadHistoryStatus() {
                let url = process.env.VUE_APP_API_HOST + "council/admin/case/models/status_history" + "?candidateCase=" + this.id
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.historyStatus = json
                })
            },
//сигнал от компонента файлов
            updateFile(item) {
                this.value[item.field] = item.file;
            },
//выбор файла
            setFile(e, field, i = undefined, field_str = undefined) {
                if (i === undefined) {
                    const file = e.target.files[0];
                    this.value[field] = file;
                } else {
                    const file = e.target.files[0];
                    this.value[field][i][field_str] = file;
                }

            },
//универсальное добавление поля
            addField(field) {
                this.value[field].push(
                    {
                        [field]: null,
                    }
                )
            },

            addField_scientific_consultant() {
                if (this.value.scientificConsultant === null)
                    this.value.scientificConsultant = []
                this.value.scientificConsultant.push(
                    {
                        "person": null,
                        "review": null,
                    }
                )
            },
            //удаление поля
            deleteData(idx, key, allDelete = false) {
                if (this.value[key].length > 1 || allDelete)
                    this.value[key].splice(idx, 1);
            },
            //рекурсивная загрузка пагинации
            load: function (app, url, data) {
                if (url === null) {
                    app.loadingPage = true;
                    return;
                }
                makeGetRequest(url)
                    .then(resp => resp.json())
                    .then(json => {
                        let next_url = null;
                        if (json['next'] !== null)
                            next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
                        for (let i in json['results']) {
                            app.selectors[data].push(Object.assign({}, json['results'][i]));
                        }
                        app.load(app, next_url, data);
                    });
            },
            //загрузка селекторов
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },

            text: item => item.name[0].text,
            //язык текущего поля
            findLang(langid) {
                let str = this.lang.find(x => x.id === langid).name;
                return str
            },
            closeDialog() {
                this.$emit('ended', '')
            },
            apply: function () {
//массив файловых полей
                let file_mass = ["statement", "eduDoc", "examDoc", "organizationConclusion",
                    "expertPublicationConclusion", "expertTradeConclusion", "personalDataConsent",
                    "passport", "thesisPDF", "thesisWORD", "synopsis", "annotation", "expertLangConclusion",
                    "expertExtremismConclusion", "expertReviewConclusion", "councilReviewProtocol",
                    "councilReviewLeafSheet", "councilProtectionProtocol",
                    "councilProtectionLeafSheet",
                    "countingCommissionProtectionProtocol",
                    "councilProtectionConclusion", "expertInternetPublicationConclusion",
                    "certificationCommissionProtocol", "rectorOrder", "diploma"]

                let url = this.URL_CREATE;
                let method = 'POST'
                if(this.id !== undefined){
                    url = this.URL_UPDATE.replace('<id>', this.id);
                    method = 'PATCH'
                }

                let data = Object.assign({}, this.value);

                var formData = new FormData();

                for (var key in data) {
                    let loadflag = true  //файл не является строкой и реален

                    if (data[key] !== undefined && data[key] !== null) {

                        for (var i = 0; i < file_mass.length; i++) {

                            if (file_mass[i] === key) {
                                if (typeof data[key] === 'string') {//если файл строка,то не грузим
                                    // formData.append(key, data[key])
                                    loadflag = false
                                } else {
                                    if ((typeof data[key] !== 'object') && (typeof data[key] !== 'string'))
                                        data[key] = new File(['/path/to/file'], 'rb')//пихаем пустоту,но как файл
                                }
                            }
                        }

                      if (key === "lastName" || key === "firstName" || key === "patronymic"
                        //json формируем и отправляем
                        || key === "thesisTopic"
                      ) {
                        let param = data[key];
                        let loadFlag = true
                        for (var i in param) {
                          if (param[i].text === '') {
                            loadFlag = false
                          }
                        }
                        if (loadFlag)
                          formData.append(key, JSON.stringify(data[key]))
                        else
                          formData.append(key, JSON.stringify({}))
                      }
                        else if (key === "scientificConsultant") {
                            var list = data["scientificConsultant"]
                            for (let str in list) {
                                let name_strperson = "scientificConsultant[" + str + "]person"  //вложенные данные отправляем плоско
                                formData.append(name_strperson, list[str].person)
                                if (typeof list[str].review !== 'string' && list[str].review !== null) { //не отправляем строки
                                    let name_strreview = "scientificConsultant[" + str + "]review"
                                    formData.append(name_strreview, list[str].review)
                                }
                            }
                        }
                        else if (key === "scientificBoss") {
                          var list = data["scientificBoss"]
                          for (let str in list) {
                            let name_strperson = "scientificBoss[" + str + "]person"  //вложенные данные отправляем плоско
                            formData.append(name_strperson, list[str].person)
                            if (typeof list[str].review !== 'string' && list[str].review !== null) { //не отправляем строки
                              let name_strreview = "scientificBoss[" + str + "]review"
                              formData.append(name_strreview, list[str].review)
                            }
                          }
                        }
                        else if (key === "scientificField") { // м2м отправка плоско
                            var lists = data["scientificField"]
                            for (let str in lists) {
                                let name_scientific = "scientificField[" + str + "]scientificField"
                                formData.append(name_scientific, lists[str].scientificField)
                            }

                        } else if (loadflag) // остальные поля
                            formData.append(key, data[key])
                    }
                }

                let status = true;
                makePostRequestFile(url, formData, method)
                    .then(resp => {
                        if (!resp.ok) {
                            status = false;
                        }
                        return resp.json()
                    })
                    .then(json => {

                        if (status) {
                            this.closeDialog()
                        } else {
                            this.receiveErrors(json);
                            if (json.detail) {
                                var detail = confirm(json.detail);
                            }
                            if (json.non_field_errors) {
                                var non_field_errors = confirm(json.non_field_errors);
                            }
                        }
                    })

            },
            //имя по ид для селектров объектов
            findNameObj(edit, id) {
                let obj = this.selectors[edit].find(item => item.value === id);
                if (obj !== undefined) {
                    return obj.text
                } else {
                    return ""
                }
            },
          loadStatus() {

            makeGetRequest(process.env.VUE_APP_API_HOST + "council/admin/case/status_info/").then(resp => {
              let sys = true;
              if (!resp.ok) {
                sys = false
              }
              return resp.json()
            }).then(json => {

              let data = json
              let sys = true;
              makeGetRequest(process.env.VUE_APP_API_HOST + "council/admin/case/choices/status_choices/").then(resp => {
                if (!resp.ok) {
                  sys = false
                }
                return resp.json()
              }).then(json => {
                this.selectors.status = json
                let dataStatus = this.selectors.status //получили все статусы
                this.selectors.nextStatus = []
                this.selectors.nextStatus.push(this.selectors.status[this.value.status]) // текущий статус
                let next_statuses = data[this.value.status] //получили все следующие статусы
                if (next_statuses !== undefined){
                  for (let key in dataStatus) { // ищем будующие статусы
                    let i = next_statuses.find(item => item == key);
                    if (i !== undefined) {
                      this.selectors.nextStatus.push(this.selectors.status[i])
                    }
                  }
                }
              })
            })
          },
          loadData() {
                let url = this.URL_UPDATE.replace('<id>', this.id);
                var sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.value = json
                    this.value.lastName = json.lastName
                    this.value.scientificBoss = []
                    this.value.firstName = json.firstName
                    if(Array.isArray(json.patronymic)){
                      this.value.patronymic = json.patronymic
                    }else{
                      this.value.patronymic =[]
                      for (let key in this.lang) {
                        this.value.patronymic.push({"text": "", "language": this.lang[key].id})
                      }
                    }
                    this.value.thesisTopic = json.thesisTopic
                    this.value.status = json.status.status
                    this.value.language = json.language.id
                    this.value.academicDegree = json.academicDegree.id
                    this.value.organization = json.organization.id
                    this.value.scientificBoss = json.scientificBoss.id
                    if (json.dissertationCouncil !== null)
                        this.value.dissertationCouncil = json.dissertationCouncil.id

                    let urlsci = new URL(process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case_scientific_field/")

                    let params = json.scientificField.get_params

                    json.scientificField.get_params.page_size = 100

                    urlsci.search = new URLSearchParams(params).toString();
                    this.loadStatus()
                    this.LoadHistoryStatus()
                    makeGetRequest(urlsci).then(resp => {
                        if (!resp.ok) {
                            sys = false
                        }
                        return resp.json()
                    }).then(json => {
                        let res = json.results

                        this.value.scientificField = []

                        for (let key in res) {

                            this.value.scientificField.push(
                                {"scientificField": res[key].scientificField}
                            )
                        }
                    })

                    let urlcon = new URL(process.env.VUE_APP_API_HOST + "council/admin/case/models/scientific_consultant/")

                    json.scientificConsultant.get_params.page_size = 100
                    params = json.scientificConsultant.get_params
                    urlcon.search = new URLSearchParams(params).toString();

                    makeGetRequest(urlcon).then(resp => {
                        if (!resp.ok) {
                            sys = false
                        }
                        return resp.json()
                    }).then(json => {
                        let res = json.results

                        this.value.scientificConsultant = []

                        for (let key in res) {

                            this.value.scientificConsultant.push(
                                {
                                    "person": res[key].person,
                                    "review": res[key].review,
                                }
                            )
                        }
                    })
                  urlcon = new URL(process.env.VUE_APP_API_HOST + "council/admin/case/models/scientific_boss/")

                  urlcon.search = new URLSearchParams(params).toString();

                  makeGetRequest(urlcon).then(resp => {
                    if (!resp.ok) {
                      sys = false
                    }
                    return resp.json()
                  }).then(json => {
                    let res = json.results

                    this.value.scientificBoss = []

                    for (let key in res) {

                      this.value.scientificBoss.push(
                        {
                          "person": res[key].person,
                          "review": res[key].review,
                        }
                      )
                    }
                  })

                })
            },
        },
        created() {
            let url = process.env.VUE_APP_API_HOST + "council/admin/core/models/language/"
            let sys = true
            makeGetRequest(url).then(resp => {
                if (!resp.ok) {
                    sys = false
                }
                return resp.json()
            }).then(json => {
                this.lang = json

                if (this.value.lastName.length === 0) {
                    for (let key in this.lang) {
                        this.value.lastName.push({"text": "", "language": this.lang[key].id})
                        this.value.firstName.push({"text": "", "language": this.lang[key].id})
                        this.value.patronymic.push({"text": "", "language": this.lang[key].id})
                        this.value.thesisTopic.push({"text": "", "language": this.lang[key].id})
                    }
                }

                url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/academic_degree/"
                this.loadSelector("academicDegree", url)

                url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/scientific_field/"
                this.loadSelector("scientificField", url)

                url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/organization/"
                this.load(this, url, "organization")

                url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/person/"
                this.load(this, url, "scientificBoss")

                url = process.env.VUE_APP_API_HOST + "council/admin/diss/selectors/dissertation_council/"
                this.loadSelector("dissertationCouncil", url)


                url = process.env.VUE_APP_API_HOST + "council/admin/case/choices/location_choices/"
                this.loadSelector("location", url)

                this.$store.commit('mainpage/changeTitle', 'Заявка');
                if(this.id !== undefined)
                  this.loadData()
            })
        }
    }


</script>

<style scoped>

</style>
